import { mockTodoResponse } from '@/mock/mockData'

function ok(data) {
  return Promise.resolve({ success: true, data })
}

/**
 * 获取待办事项列表
 * @param {Object} params - 请求参数
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页大小
 * @param {number} params.status - 状态 (0: 待处理, 1: 已处理)
 * @returns {Promise} 请求结果
 */
export function getTodoList(params = {}) {
  return ok(mockTodoResponse(params.pageNum, params.pageSize, params.status))
}

/**
 * 标记待办事项为已处理
 * @param {number} id - 待办事项ID
 * @returns {Promise} 请求结果
 */
export function markTodoAsProcessed(id) {
  return ok({ id })
}

/**
 * 获取待办事项详情
 * @param {number} id - 待办事项ID
 * @returns {Promise} 请求结果
 */
export function getTodoDetail(id) {
  const listData = mockTodoResponse(1, 10000).list.list
  const todoItem = listData.find(item => Number(item.id) === Number(id))
  return ok(todoItem || null)
}
